module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "dialog dialog-shadow",
    staticStyle: {
      "display": "block",
      "margin-top": "-362px"
    }
  }, [_c('div', {
    staticClass: "title"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "common-form"
  }, [_c('li', [_c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registered.userName),
      expression: "registered.userName"
    }],
    attrs: {
      "type": "phone",
      "placeholder": "手机号码"
    },
    domProps: {
      "value": (_vm.registered.userName)
    },
    on: {
      "keyup": function($event) {
        _vm.registered.userName = _vm.registered.userName.replace(/[^\w\.\/]/ig, '')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registered, "userName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registered.userPwd),
      expression: "registered.userPwd"
    }],
    attrs: {
      "type": "password",
      "placeholder": "登录密码"
    },
    domProps: {
      "value": (_vm.registered.userPwd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registered, "userPwd", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registered.userPwd2),
      expression: "registered.userPwd2"
    }],
    attrs: {
      "type": "password",
      "placeholder": "重复密码"
    },
    domProps: {
      "value": (_vm.registered.userPwd2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registered, "userPwd2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "input-sms"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registered.smsCode),
      expression: "registered.smsCode"
    }],
    attrs: {
      "type": "number",
      "placeholder": "短信验证码",
      "disabled": !_vm.smsFlag
    },
    domProps: {
      "value": (_vm.registered.smsCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registered, "smsCode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('y-button', {
    staticStyle: {
      "margin": "0",
      "width": "35%"
    },
    attrs: {
      "classStyle": _vm.registered.userName.length === 11 && !_vm.smsFlag && _vm.smstxt === '获取验证码' ? 'main-btn' : 'disabled-btn',
      "text": _vm.smstxt
    },
    on: {
      "btnClick": _vm.snedSmsCode
    }
  })], 1)])]), _vm._v(" "), _c('el-checkbox', {
    staticClass: "agree",
    model: {
      value: (_vm.agreement),
      callback: function($$v) {
        _vm.agreement = $$v
      },
      expression: "agreement"
    }
  }, [_vm._v("\n          我已阅读并同意遵守\n          "), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openAgree('01')
      }
    }
  }, [_vm._v("网站免责声明")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "20px 0"
    }
  }, [_c('y-button', {
    staticStyle: {
      "margin": "0",
      "width": "100%",
      "height": "48px",
      "font-size": "18px",
      "line-height": "48px"
    },
    attrs: {
      "classStyle": _vm.registered.userPwd && _vm.registered.userPwd2 && _vm.registered.userName && _vm.registered.smsCode && _vm.registxt === '注册' ? 'main-btn' : 'disabled-btn',
      "text": _vm.registxt
    },
    on: {
      "btnClick": _vm.register
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "border",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "common-form pr"
  }, [_c('li', {
    staticStyle: {
      "text-align": "center",
      "line-height": "48px",
      "margin-bottom": "0",
      "font-size": "12px",
      "color": "#999",
      "width": "100%"
    }
  }, [_c('span', [_vm._v("如果您已拥有账号，")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.toLogin
    }
  }, [_vm._v("立即登陆")]), _vm._v(" "), _c('span', [_vm._v("|")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('span', [_vm._v("无法接收验证码，")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.toCustom
    }
  }, [_vm._v("联系客服")])])])])], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.dialogTitle,
      "visible": _vm.dialogVisible,
      "center": true,
      "width": "60%",
      "top": "8vh"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-content"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.dialogContent)
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.closeAgree()
      }
    }
  }, [_vm._v("我已阅读")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70bda0bd","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login/register.vue
// module id = 661
// module chunks = 0